// import { useCallback, useRef } from "react";

// export default function useMobileTouch({
//   mapWidth,
//   mapHeight,
//   zoom,
//   setZoom,
//   setPos,
//   setDragging,
//   setVelocity,
//   dragging,
//   lastPos,
//   setLastPos,
//   velocity,
//   minZoom = 0.1,
//   maxZoom = 1.8,
// }) {
//   const lastDistance = useRef(null);
//   const pinchCenter = useRef(null);
//   const isPinching = useRef(false);
//   const pinchVelocity = useRef(0);
//   const lastTapTime = useRef(0);

//   // 🟢 لمس الشاشة (إصبع أو إصبعين)
//   const onTouchStart = useCallback(
//     (e) => {
//       const now = Date.now();
//       const timeSinceLastTap = now - lastTapTime.current;

//       // ✅ Double-tap zoom (تكبير عند اللمس مرتين بسرعة)
//       if (e.touches.length === 1 && timeSinceLastTap < 300) {
//         e.preventDefault();

//         const touch = e.touches[0];
//         const rect = document
//           .getElementById("map-container")
//           .getBoundingClientRect();

//         const tapX = touch.clientX - rect.left;
//         const tapY = touch.clientY - rect.top;

//         const targetZoom = Math.min(zoom * 1.5, maxZoom);
//         const zoomRatio = targetZoom / zoom;

//         // نعدّل الإحداثيات علشان نكبّر حوالين النقطة اللي ضغط عليها
//         setPos((prev) => {
//           const newX = tapX - (tapX - prev.x) * zoomRatio;
//           const newY = tapY - (tapY - prev.y) * zoomRatio;
//           return { x: newX, y: newY };
//         });

//         // انسيابية في الزوم
//         let currentZoom = zoom;
//         const animateZoom = () => {
//           currentZoom += (targetZoom - currentZoom) * 0.2;
//           setZoom(currentZoom);
//           if (Math.abs(targetZoom - currentZoom) > 0.001)
//             requestAnimationFrame(animateZoom);
//         };
//         requestAnimationFrame(animateZoom);

//         lastTapTime.current = 0; // reset بعد التكبير
//         return;
//       }

//       lastTapTime.current = now;

//       // 🟢 اللمس العادي أو الـ pinch
//       if (e.touches.length === 1) {
//         const touch = e.touches[0];
//         setDragging(true);
//         setLastPos({ x: touch.clientX, y: touch.clientY });
//         setVelocity({ x: 0, y: 0 });
//       } else if (e.touches.length === 2) {
//         isPinching.current = true;

//         const dx = e.touches[0].clientX - e.touches[1].clientX;
//         const dy = e.touches[0].clientY - e.touches[1].clientY;
//         lastDistance.current = Math.sqrt(dx * dx + dy * dy);

//         pinchCenter.current = {
//           x: (e.touches[0].clientX + e.touches[1].clientX) / 2,
//           y: (e.touches[0].clientY + e.touches[1].clientY) / 2,
//         };

//         pinchVelocity.current = 0;
//       }
//     },
//     [setDragging, setLastPos, setVelocity, zoom, setZoom, setPos, maxZoom]
//   );

//   // 🟢 أثناء التحريك أو التكبير
//   const onTouchMove = useCallback(
//     (e) => {
//       if (e.touches.length === 1 && dragging && !isPinching.current) {
//         // سحب بإصبع واحد
//         const touch = e.touches[0];
//         const dx = touch.clientX - lastPos.x;
//         const dy = touch.clientY - lastPos.y;

//         setLastPos({ x: touch.clientX, y: touch.clientY });
//         setVelocity({ x: dx / 16, y: dy / 16 });

//         setPos((prev) => {
//           const scaledWidth = mapWidth * zoom;
//           const scaledHeight = mapHeight * zoom;
//           const maxX = 0;
//           const maxY = 0;
//           const minX =
//             scaledWidth < window.innerWidth
//               ? (window.innerWidth - scaledWidth) / 2
//               : -scaledWidth + window.innerWidth;
//           const minY =
//             scaledHeight < window.innerHeight
//               ? (window.innerHeight - scaledHeight) / 2
//               : -scaledHeight + window.innerHeight;

//           let newX = prev.x + dx;
//           let newY = prev.y + dy;

//           return {
//             x: Math.max(Math.min(newX, maxX), minX),
//             y: Math.max(Math.min(newY, maxY), minY),
//           };
//         });
//       } else if (e.touches.length === 2) {
//         // تكبير/تصغير بإصبعين (Pinch)
//         const dx = e.touches[0].clientX - e.touches[1].clientX;
//         const dy = e.touches[0].clientY - e.touches[1].clientY;
//         const newDistance = Math.sqrt(dx * dx + dy * dy);

//         if (lastDistance.current) {
//           const scaleChange = newDistance / lastDistance.current;
//           pinchVelocity.current = scaleChange - 1;

//           let newZoom = zoom * scaleChange;
//           newZoom = Math.max(Math.min(newZoom, maxZoom), minZoom);

//           const rect = document
//             .getElementById("map-container")
//             .getBoundingClientRect();

//           const centerX = pinchCenter.current.x - rect.left;
//           const centerY = pinchCenter.current.y - rect.top;

//           const zoomRatio = newZoom / zoom;
//           setPos((prev) => {
//             let newX = centerX - (centerX - prev.x) * zoomRatio;
//             let newY = centerY - (centerY - prev.y) * zoomRatio;

//             const scaledWidth = mapWidth * newZoom;
//             const scaledHeight = mapHeight * newZoom;
//             const maxX = 0;
//             const maxY = 0;
//             const minX =
//               scaledWidth < window.innerWidth
//                 ? (window.innerWidth - scaledWidth) / 2
//                 : -scaledWidth + window.innerWidth;
//             const minY =
//               scaledHeight < window.innerHeight
//                 ? (window.innerHeight - scaledHeight) / 2
//                 : -scaledHeight + window.innerHeight;

//             newX = Math.max(Math.min(newX, maxX), minX);
//             newY = Math.max(Math.min(newY, maxY), minY);

//             return { x: newX, y: newY };
//           });

//           setZoom(newZoom);
//         }

//         lastDistance.current = newDistance;
//       }
//     },
//     [
//       dragging,
//       lastPos,
//       mapWidth,
//       mapHeight,
//       zoom,
//       setPos,
//       setVelocity,
//       setLastPos,
//       setZoom,
//       minZoom,
//       maxZoom,
//     ]
//   );

//   // 🟢 لما ترفعي صباعك
//   const onTouchEnd = useCallback(() => {
//     if (isPinching.current) {
//       // 👇 انسيابية بعد الـ pinch
//       isPinching.current = false;
//       let currentZoom = zoom;
//       let decay = 0.9;
//       let velocityZ = pinchVelocity.current * 5;

//       const smoothZoom = () => {
//         velocityZ *= decay;
//         currentZoom += velocityZ;
//         currentZoom = Math.max(Math.min(currentZoom, maxZoom), minZoom);

//         setZoom(currentZoom);

//         if (Math.abs(velocityZ) > 0.001) {
//           requestAnimationFrame(smoothZoom);
//         }
//       };

//       requestAnimationFrame(smoothZoom);

//       lastDistance.current = null;
//       pinchVelocity.current = 0;
//       return;
//     }

//     if (!dragging) return;
//     setDragging(false);

//     let vx = velocity.x * 0.5;
//     let vy = velocity.y * 0.5;
//     const decay = 0.75;
//     const speedFactor = 15;

//     const animate = () => {
//       setPos((prev) => {
//         const scaledWidth = mapWidth * zoom;
//         const scaledHeight = mapHeight * zoom;
//         const maxX = 0;
//         const maxY = 0;
//         const minX =
//           scaledWidth < window.innerWidth
//             ? (window.innerWidth - scaledWidth) / 2
//             : -scaledWidth + window.innerWidth;
//         const minY =
//           scaledHeight < window.innerHeight
//             ? (window.innerHeight - scaledHeight) / 2
//             : -scaledHeight + window.innerHeight;

//         let newX = prev.x + vx * speedFactor;
//         let newY = prev.y + vy * speedFactor;

//         if (newX >= maxX || newX <= minX) vx = 0;
//         if (newY >= maxY || newY <= minY) vy = 0;

//         newX = Math.max(Math.min(newX, maxX), minX);
//         newY = Math.max(Math.min(newY, maxY), minY);

//         return { x: newX, y: newY };
//       });

//       vx *= decay;
//       vy *= decay;

//       if (Math.abs(vx) > 0.01 || Math.abs(vy) > 0.01) {
//         requestAnimationFrame(animate);
//       }
//     };

//     requestAnimationFrame(animate);
//   }, [dragging, mapWidth, mapHeight, zoom, setPos, setZoom, velocity, setDragging, minZoom, maxZoom]);

//   const onTouchCancel = useCallback(() => {
//     setDragging(false);
//     isPinching.current = false;
//     lastDistance.current = null;
//   }, [setDragging]);

//   return {
//     onTouchStart,
//     onTouchMove,
//     onTouchEnd,
//     onTouchCancel,
//   };
// }

















// import { useCallback, useRef } from "react";

// export default function useMobileTouch({
//   mapWidth,
//   mapHeight,
//   zoom,
//   setZoom,
//   setPos,
//   setDragging,
//   setVelocity,
//   dragging,
//   lastPos,
//   setLastPos,
//   velocity,
//   minZoom = 0.1,
//   maxZoom = 1.8,
// }) {
//   const lastDistance = useRef(null);
//   const pinchCenter = useRef(null);
//   const isPinching = useRef(false);
//   const pinchVelocity = useRef(0);
//   const lastTapTime = useRef(0);

//   // 🟢 لمس الشاشة (إصبع أو إصبعين)
//   const onTouchStart = useCallback(
//     (e) => {
//       const now = Date.now();
//       const timeSinceLastTap = now - lastTapTime.current;

//       // ✅ Double-tap zoom (تكبير عند اللمس مرتين بسرعة)
//       if (e.touches.length === 1 && timeSinceLastTap < 300) {
//         e.preventDefault();

//         const touch = e.touches[0];
//         const rect = document
//           .getElementById("map-container")
//           .getBoundingClientRect();

//         const tapX = touch.clientX - rect.left;
//         const tapY = touch.clientY - rect.top;

//         const targetZoom = Math.min(zoom * 1.5, maxZoom);
//         const zoomRatio = targetZoom / zoom;

//         // نعدّل الإحداثيات علشان نكبّر حوالين النقطة اللي ضغط عليها
//         setPos((prev) => {
//           const newX = tapX - (tapX - prev.x) * zoomRatio;
//           const newY = tapY - (tapY - prev.y) * zoomRatio;
//           return { x: newX, y: newY };
//         });

//         // انسيابية في الزوم
//         let currentZoom = zoom;
//         const animateZoom = () => {
//           currentZoom += (targetZoom - currentZoom) * 0.2;
//           setZoom(currentZoom);
//           if (Math.abs(targetZoom - currentZoom) > 0.001)
//             requestAnimationFrame(animateZoom);
//         };
//         requestAnimationFrame(animateZoom);

//         lastTapTime.current = 0; // reset بعد التكبير
//         return;
//       }

//       lastTapTime.current = now;

//       // 🟢 اللمس العادي أو الـ pinch
//       if (e.touches.length === 1) {
//         const touch = e.touches[0];
//         setDragging(true);
//         setLastPos({ x: touch.clientX, y: touch.clientY });
//         setVelocity({ x: 0, y: 0 });
//       } else if (e.touches.length === 2) {
//         isPinching.current = true;

//         const dx = e.touches[0].clientX - e.touches[1].clientX;
//         const dy = e.touches[0].clientY - e.touches[1].clientY;
//         lastDistance.current = Math.sqrt(dx * dx + dy * dy);

//         pinchCenter.current = {
//           x: (e.touches[0].clientX + e.touches[1].clientX) / 2,
//           y: (e.touches[0].clientY + e.touches[1].clientY) / 2,
//         };

//         pinchVelocity.current = 0;
//       }
//     },
//     [setDragging, setLastPos, setVelocity, zoom, setZoom, setPos, maxZoom]
//   );

//   // 🟢 أثناء التحريك أو التكبير
//   const onTouchMove = useCallback(
//     (e) => {
//       if (e.touches.length === 1 && dragging && !isPinching.current) {
//         // سحب بإصبع واحد
//         const touch = e.touches[0];
//         const dx = touch.clientX - lastPos.x;
//         const dy = touch.clientY - lastPos.y;

//         setLastPos({ x: touch.clientX, y: touch.clientY });
//         setVelocity({ x: dx / 16, y: dy / 16 });

//         setPos((prev) => {
//           const scaledWidth = mapWidth * zoom;
//           const scaledHeight = mapHeight * zoom;
//           const maxX = 0;
//           const maxY = 0;
//           const minX =
//             scaledWidth < window.innerWidth
//               ? (window.innerWidth - scaledWidth) / 2
//               : -scaledWidth + window.innerWidth;
//           const minY =
//             scaledHeight < window.innerHeight
//               ? (window.innerHeight - scaledHeight) / 2
//               : -scaledHeight + window.innerHeight;

//           let newX = prev.x + dx;
//           let newY = prev.y + dy;

//           return {
//             x: Math.max(Math.min(newX, maxX), minX),
//             y: Math.max(Math.min(newY, maxY), minY),
//           };
//         });
//       } else if (e.touches.length === 2) {
//         // تكبير/تصغير بإصبعين (Pinch)
//         const dx = e.touches[0].clientX - e.touches[1].clientX;
//         const dy = e.touches[0].clientY - e.touches[1].clientY;
//         const newDistance = Math.sqrt(dx * dx + dy * dy);

//         if (lastDistance.current) {
//           const scaleChange = newDistance / lastDistance.current;
//           pinchVelocity.current = scaleChange - 1;

//           let newZoom = zoom * scaleChange;
//           newZoom = Math.max(Math.min(newZoom, maxZoom), minZoom);

//           const rect = document
//             .getElementById("map-container")
//             .getBoundingClientRect();

//           const centerX = pinchCenter.current.x - rect.left;
//           const centerY = pinchCenter.current.y - rect.top;

//           const zoomRatio = newZoom / zoom;
//           setPos((prev) => {
//             let newX = centerX - (centerX - prev.x) * zoomRatio;
//             let newY = centerY - (centerY - prev.y) * zoomRatio;

//             const scaledWidth = mapWidth * newZoom;
//             const scaledHeight = mapHeight * newZoom;
//             const maxX = 0;
//             const maxY = 0;
//             const minX =
//               scaledWidth < window.innerWidth
//                 ? (window.innerWidth - scaledWidth) / 2
//                 : -scaledWidth + window.innerWidth;
//             const minY =
//               scaledHeight < window.innerHeight
//                 ? (window.innerHeight - scaledHeight) / 2
//                 : -scaledHeight + window.innerHeight;

//             newX = Math.max(Math.min(newX, maxX), minX);
//             newY = Math.max(Math.min(newY, maxY), minY);

//             return { x: newX, y: newY };
//           });

//           setZoom(newZoom);
//         }

//         lastDistance.current = newDistance;
//       }
//     },
//     [
//       dragging,
//       lastPos,
//       mapWidth,
//       mapHeight,
//       zoom,
//       setPos,
//       setVelocity,
//       setLastPos,
//       setZoom,
//       minZoom,
//       maxZoom,
//     ]
//   );

//   // 🟢 لما ترفعي صباعك
//   const onTouchEnd = useCallback(() => {
//     if (isPinching.current) {
//       // 👇 انسيابية بعد الـ pinch
//       isPinching.current = false;
//       let currentZoom = zoom;
//       let decay = 0.9;
//       let velocityZ = pinchVelocity.current * 5;

//       const smoothZoom = () => {
//         velocityZ *= decay;
//         currentZoom += velocityZ;
//         currentZoom = Math.max(Math.min(currentZoom, maxZoom), minZoom);

//         setZoom(currentZoom);

//         if (Math.abs(velocityZ) > 0.001) {
//           requestAnimationFrame(smoothZoom);
//         }
//       };

//       requestAnimationFrame(smoothZoom);

//       lastDistance.current = null;
//       pinchVelocity.current = 0;
//       return;
//     }

//     if (!dragging) return;
//     setDragging(false);

//     let vx = velocity.x * 0.5;
//     let vy = velocity.y * 0.5;
//     const decay = 0.75;
//     const speedFactor = 15;

//     const animate = () => {
//       setPos((prev) => {
//         const scaledWidth = mapWidth * zoom;
//         const scaledHeight = mapHeight * zoom;
//         const maxX = 0;
//         const maxY = 0;
//         const minX =
//           scaledWidth < window.innerWidth
//             ? (window.innerWidth - scaledWidth) / 2
//             : -scaledWidth + window.innerWidth;
//         const minY =
//           scaledHeight < window.innerHeight
//             ? (window.innerHeight - scaledHeight) / 2
//             : -scaledHeight + window.innerHeight;

//         let newX = prev.x + vx * speedFactor;
//         let newY = prev.y + vy * speedFactor;

//         if (newX >= maxX || newX <= minX) vx = 0;
//         if (newY >= maxY || newY <= minY) vy = 0;

//         newX = Math.max(Math.min(newX, maxX), minX);
//         newY = Math.max(Math.min(newY, maxY), minY);

//         return { x: newX, y: newY };
//       });

//       vx *= decay;
//       vy *= decay;

//       if (Math.abs(vx) > 0.01 || Math.abs(vy) > 0.01) {
//         requestAnimationFrame(animate);
//       }
//     };

//     requestAnimationFrame(animate);
//   }, [dragging, mapWidth, mapHeight, zoom, setPos, setZoom, velocity, setDragging, minZoom, maxZoom]);

//   const onTouchCancel = useCallback(() => {
//     setDragging(false);
//     isPinching.current = false;
//     lastDistance.current = null;
//   }, [setDragging]);

//   return {
//     onTouchStart,
//     onTouchMove,
//     onTouchEnd,
//     onTouchCancel,
//   };
// }


















import { useCallback, useRef } from "react";

export default function useMobileTouch({
  mapWidth,
  mapHeight,
  zoom,
  setZoom,
  setPos,
  setDragging,
  setVelocity,
  dragging,
  lastPos,
  setLastPos,
  velocity,
  minZoom = 0.1,
  maxZoom = 1.8,
  containerId = "map-container" // جعلناه ديناميكي
}) {
  const lastDistance = useRef(null);
  const pinchCenter = useRef(null);
  const isPinching = useRef(false);
  const pinchVelocity = useRef(0);
  const lastTapTime = useRef(0);

  const getContainerRect = () => document.getElementById(containerId)?.getBoundingClientRect();

  const onTouchStart = useCallback((e) => {
    const now = Date.now();
    const timeSinceLastTap = now - lastTapTime.current;

    // --- 1. Double Tap Zoom ---
    if (e.touches.length === 1 && timeSinceLastTap < 300) {
      e.preventDefault();
      const rect = getContainerRect();
      const touch = e.touches[0];
      
      const tapX = touch.clientX - rect.left;
      const tapY = touch.clientY - rect.top;

      const targetZoom = Math.min(zoom * 1.5, maxZoom);
      const zoomRatio = targetZoom / zoom;

      setPos((prev) => ({
        x: tapX - (tapX - prev.x) * zoomRatio,
        y: tapY - (tapY - prev.y) * zoomRatio,
      }));
      setZoom(targetZoom);
      
      lastTapTime.current = 0;
      return;
    }

    lastTapTime.current = now;

    // --- 2. Pinch or Single Touch Setup ---
    if (e.touches.length === 1) {
      const touch = e.touches[0];
      setDragging(true);
      isPinching.current = false;
      setLastPos({ x: touch.clientX, y: touch.clientY });
      setVelocity({ x: 0, y: 0 });
    } else if (e.touches.length === 2) {
      setDragging(false); // نوقف السحب العادي لو في إصبعين
      isPinching.current = true;
      const dx = e.touches[0].clientX - e.touches[1].clientX;
      const dy = e.touches[0].clientY - e.touches[1].clientY;
      lastDistance.current = Math.sqrt(dx * dx + dy * dy);
      
      pinchCenter.current = {
        x: (e.touches[0].clientX + e.touches[1].clientX) / 2,
        y: (e.touches[0].clientY + e.touches[1].clientY) / 2,
      };
    }
  }, [zoom, maxZoom, setPos, setZoom, setDragging, setLastPos, setVelocity, containerId]);

const onTouchMove = useCallback(
  (e) => {
    const rect = getContainerRect();
    if (!rect) return;

    if (e.touches.length === 1 && !isPinching.current) {
      // 1️⃣ سحب عادي بإصبع واحد
      const touch = e.touches[0];
      const dx = touch.clientX - lastPos.x;
      const dy = touch.clientY - lastPos.y;

      setLastPos({ x: touch.clientX, y: touch.clientY });

      setPos((prev) => {
        const scaledWidth = mapWidth * zoom;
        const scaledHeight = mapHeight * zoom;

        // حساب الحدود (نفس منطق الديسكتوب)
        const maxX = 0;
        const maxY = 0;
        const minX = Math.min(0, window.innerWidth - scaledWidth);
        const minY = Math.min(0, window.innerHeight - scaledHeight);

        // تطبيق الحركة مع القص (Clamping)
        return {
          x: Math.max(minX, Math.min(maxX, prev.x + dx)),
          y: Math.max(minY, Math.min(maxY, prev.y + dy)),
        };
      });
    } 
    else if (e.touches.length === 2) {
      // 2️⃣ زوم بإصبعين (Pinch)
      const dx = e.touches[0].clientX - e.touches[1].clientX;
      const dy = e.touches[0].clientY - e.touches[1].clientY;
      const newDistance = Math.sqrt(dx * dx + dy * dy);

      if (lastDistance.current) {
        const scaleChange = newDistance / lastDistance.current;
        let newZoom = Math.max(minZoom, Math.min(maxZoom, zoom * scaleChange));

        const centerX = (e.touches[0].clientX + e.touches[1].clientX) / 2 - rect.left;
        const centerY = (e.touches[0].clientY + e.touches[1].clientY) / 2 - rect.top;

        const zoomRatio = newZoom / zoom;

        setPos((prev) => {
          let newX = centerX - (centerX - prev.x) * zoomRatio;
          let newY = centerY - (centerY - prev.y) * zoomRatio;

          // حتى وأنتِ بتعملي زوم، لازم نضمن إن الصورة متهربش
          const scaledWidth = mapWidth * newZoom;
          const scaledHeight = mapHeight * newZoom;
          
          const minX = Math.min(0, window.innerWidth - scaledWidth);
          const minY = Math.min(0, window.innerHeight - scaledHeight);

          return {
            x: Math.max(minX, Math.min(0, newX)),
            y: Math.max(minY, Math.min(0, newY)),
          };
        });
        setZoom(newZoom);
      }
      lastDistance.current = newDistance;
    }
  },
  [zoom, lastPos, mapWidth, mapHeight, maxZoom, minZoom, containerId, setPos, setZoom, setLastPos]
);
  const onTouchEnd = useCallback(() => {
    lastDistance.current = null;
    isPinching.current = false;
    setDragging(false);
  }, [setDragging]);

  return { onTouchStart, onTouchMove, onTouchEnd };
}